import * as React from "react"
import { Container } from "react-grid-system"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import H1 from "../atoms/typography/H1"
import { useMyOrganization } from "../../hooks/useMyOrganization"
import { navigationItems } from "../../utils/paths"
import LoadingSpinner from "../atoms/LoadingSpinner"
import SubpagesNavigationBar from "../molecules/SubpagesNavigationBar"
import { HorizontalSpacer } from "../atoms/spacers"
import ActivityLog from "./organization/ActivityLog"
import DetailsPage from "./organization/DetailsPage"
import GroupsPage from "./organization/GroupsPage"
import LandingPage from "./organization/LandingPage"
import MembersPage from "./organization/MembersPage"
import ReceiptsPage from "./ReceiptsPage"
import { useOrganizationReceipts } from "../../hooks/useOrganizationReceipts"
import TerminalsPage from "./organization/TerminalsPage"
import SuborganizationsPage from "./organization/SuborganizationsPage"

const OrganizationPage: React.FunctionComponent = () => {
  const { myOrganization, orgLoading } = useMyOrganization()

  const hasOrg = myOrganization ? true : false

  const { t } = useTranslation()
  const { slug } = useParams()

  React.useEffect(() => {
    document.title = "Organization"
  }, [])

  return (
    <div>
      <Container>
        <HorizontalSpacer spacing={2} />
        <H1>{hasOrg ? myOrganization?.name : t("organization")}</H1>
        <HorizontalSpacer spacing={2} />
        {orgLoading ? (
          <LoadingSpinner />
        ) : (
          <div>
            {hasOrg ? (
              <>
                <SubpagesNavigationBar items={navigationItems} selectedItem={slug ?? "details"} />
                <HorizontalSpacer spacing={2} />
                {!slug && <DetailsPage />}
                {slug === "receipts" && <ReceiptsPage queryHook={useOrganizationReceipts} />}
                {slug === "details" && <DetailsPage />}
                {slug === "activity-log" && <ActivityLog />}
                {slug === "members" && <MembersPage />}
                {slug === "groups" && <GroupsPage />}
                {slug === "terminals" && <TerminalsPage />}
                {slug === "suborganizations" && <SuborganizationsPage />}
              </>
            ) : (
              <LandingPage />
            )}
          </div>
        )}
      </Container>
      <HorizontalSpacer spacing={2} />
    </div>
  )
}

export default OrganizationPage
